import { ADD_BANK, DELETE_BANK, GET_All_BANK, GET_BANK, UPDATE_BANK, GET_ONE_BANK } from "../types";
  
  const initialState = { list: [],
    listAllBank:[], 
    single: null, 
    pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
    },
    totalCount: 0  
  };
  
  const reducer = (state = initialState, action) => {
    const { type, payload, totalCount } = action;
  
    switch (type) {
      case GET_BANK:
        return { ...state, list: payload.data, totalCount: totalCount, pagination: payload.pagination  };
      
      case GET_All_BANK:
        return { ...state, listAllBank: payload, totalCount: totalCount };
  
      case UPDATE_BANK:
        return {
          ...state,
          list: state.list.map((item) =>
            item.id === payload.id ? payload : item
          ),
        };
  
      case ADD_BANK:
        return {
          ...state,
          list: [payload, ...state.list],
          totalCount: state.totalCount + 1
        };
  
      case DELETE_BANK:
        return {
          ...state,
          list: state.list.filter((item) => item.id !== payload.id),
          totalCount: state.totalCount - 1
        };
        
      case GET_ONE_BANK:
        return { ...state, single: payload };
        
      default:
        return state;
    }
  };
  
  export default reducer;
  